import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { PatchObjectResponse } from 'shared/types/object.type'
import { useSelectAndLink } from 'site/Renderer/components/SelectAndLink'
import type { FullSelectionOption } from 'site/Renderer/components/SelectAndLink/SelectAndLink.types'
import verifySelectedRelationsLinked from './verifySelectedRelationsLinked'

type Params = {
  isUniselectionRelation: boolean
  selectAndLinkSelectedOptions: FullSelectionOption[] | undefined
  changeAndSave: (
    fieldColumn: string,
    value: YesObject[string]
  ) => Promise<PatchObjectResponse | undefined>
  currentField: string
  relationWorkingSet: YesObject[]
  refetchObjects: () => unknown
  relationCounterpartColumn: string
  fieldValues: YesObject | undefined
  objectclassUuid: string
  onScrollToRelationTable: () => void
}

const useRelationClassRelationSave = ({
  isUniselectionRelation,
  selectAndLinkSelectedOptions,
  changeAndSave,
  currentField,
  relationWorkingSet,
  refetchObjects,
  relationCounterpartColumn,
  fieldValues,
  objectclassUuid,
  onScrollToRelationTable
}: Params) => {
  const { onClearSelection } = useSelectAndLink()

  return useCallback(async () => {
    const sessionSelection = isUniselectionRelation
      ? selectAndLinkSelectedOptions?.slice(-1)
      : selectAndLinkSelectedOptions
    const normalizedRelationWorkingSet = isUniselectionRelation
      ? relationWorkingSet.slice(-1)
      : relationWorkingSet
    const response = await changeAndSave(
      currentField,
      normalizedRelationWorkingSet
    )
    await refetchObjects()

    if (
      !response?.success ||
      !sessionSelection?.length ||
      !relationCounterpartColumn ||
      !fieldValues?.uuid
    ) {
      return
    }

    const verified = await verifySelectedRelationsLinked({
      objectclassUuid,
      relationCounterpartColumn,
      mainObjectUuid: String(fieldValues.uuid),
      selectedUuids: sessionSelection.map((o) => o.uuid)
    })

    if (verified) {
      onClearSelection(currentField)
      onScrollToRelationTable()
    }
  }, [
    selectAndLinkSelectedOptions,
    isUniselectionRelation,
    changeAndSave,
    currentField,
    relationWorkingSet,
    refetchObjects,
    relationCounterpartColumn,
    fieldValues?.uuid,
    objectclassUuid,
    onClearSelection,
    onScrollToRelationTable
  ])
}

export default useRelationClassRelationSave
